__turbopack_context__.v({
  "accordion": "orlHdG_accordion",
  "accordion-detail": "orlHdG_accordion-detail",
  "accordion-summary": "orlHdG_accordion-summary",
  "accordion-summary-text": "orlHdG_accordion-summary-text",
});
